import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import RecommendationButton from './RecommendationButton';
import RecommendationKPI from './RecommendationKPI';
import styles from './styles';
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { isAssignedDriverRecommendedAgain } from '../../headerRenderer/utils';
import { isCompletedOrFuturePickup } from '../../../../../utils/utils';
import { isPickupGroupHeader } from '../../../GroupPickup/utils';

const RecommendationRenderer = (props) => {
  const { classes, value: recommendedDriver, context, ...otherProps } = props;
  const pickupRecommendedData = props.api.runCommand?.('recommendedDriverByGroupId', {
    groupId: props.data?.groupId
  })
  if (
    !isPickupGroupHeader(props.data) ||
    isCompletedOrFuturePickup(props.data) ||
    isAssignedDriverRecommendedAgain(props.data.driverId, pickupRecommendedData?.driverId)
  ) {
    return null;
  }
  return pickupRecommendedData ? (
    <div className={classes.root}>
      <Tooltip
        enterDelay={pickupRecommendedData.routeId ? 500 : 0} //adding .5 sec delay, to avoid unintentional recommendation KPI api call
        title={
          pickupRecommendedData.routeId ? (
            <RecommendationKPI
              api={props.api}
              groupId={props.data?.groupId}
              routeId={pickupRecommendedData.routeId}
            />
          ) : (
            pickupRecommendedData.recommendationNotes
          )
        }
        classes={{
          tooltip: pickupRecommendedData.routeId ? classes.tooltip : classes.noteTooltip,
          popper: classes.customTooltip
        }}>
        <span className={classes.driverName}>
          {recommendedDriver ||
            (pickupRecommendedData.recommendationNotes && (
              <>
                <ErrorOutlineIcon className={classes.noteTooltipWarning} />
                <span className={classes.noFeasibleDriver}>
                  {pickupRecommendedData.recommendationNotes}
                </span>
              </>
            ))}
        </span>
      </Tooltip>
      {pickupRecommendedData.routeId && (
        <RecommendationButton
          {...otherProps}
          recommendedDriverId={pickupRecommendedData?.driverId}
          customClass={classes.assignButton}
        />
      )}
    </div>
  ) : null;
};

export default withStyles(styles)(RecommendationRenderer);
